import { Box, Typography, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { ContainerFormFormik } from 'components/shared/container_form_formik';
import InputComLabelFormik from 'components/shared/custom_input_label_formik';
import { useStep1 } from './useStep1';
import ButtonForm from 'components/buttons/button-form';

const Step1: React.FC = () => {
  const { formik, handleAvancar, handleVoltar, stepAtual, totalSteps } = useStep1();

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          mt: 4,
          mb: 4,
          fontSize: '24px',
          fontWeight: 400,
          textAlign: 'center'
        }}
      >
        Informações Gerais
      </Typography>
      <ContainerFormFormik title='Dados Básicos' onSubmit={formik.handleSubmit}>
        <Box
          sx={{ borderBottom: 1, borderColor: 'divider' }}
          display={'flex'}
          flexDirection={'column'}
        >

          <FormControl fullWidth margin='normal' error={formik.touched.tipo_unidade_administrativa && Boolean(formik.errors.tipo_unidade_administrativa)} required>
            <InputLabel>Tipo da Unidade Administrativa</InputLabel>
            <Select
              name='tipo_unidade_administrativa'
              value={formik.values.tipo_unidade_administrativa ?? ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label='Tipo da Unidade Administrativa'
            >
              <MenuItem value="">
                <em>Selecione uma opção</em>
              </MenuItem>
              <MenuItem value="Secretaria">Secretaria</MenuItem>
              <MenuItem value="Superintendência">Superintendência</MenuItem>
              <MenuItem value="Setor">Setor</MenuItem>
              <MenuItem value="Diretoria">Diretoria</MenuItem>
              <MenuItem value="Departamento">Departamento</MenuItem>
              <MenuItem value="Coordenadoria">Coordenadoria</MenuItem>
              <MenuItem value="Gerência">Gerência</MenuItem>
            </Select>
            <FormHelperText>{formik.touched.tipo_unidade_administrativa && (formik.errors.tipo_unidade_administrativa as string)}</FormHelperText>
          </FormControl>

          <InputComLabelFormik
            formik={formik}
            label='nome_secretaria'
            labelTexto='Nome da Unidade Administrativa'
            placeholder='Secretaria Municipal de Agricultura'
            required
          />

          <Box display={'flex'} gap={2}>
            <InputComLabelFormik
              formik={formik}
              label='endereco'
              labelTexto='Endereço /Rua/Avenida'
              placeholder='Rua das Flores, 123'
              width='50%'
              required
            />
            <InputComLabelFormik
              formik={formik}
              label='endereco_numero'
              labelTexto='Número (Opcional)'
              placeholder='123'
              width='50%'
              mask='numero'
            />
          </Box>

          <InputComLabelFormik
            formik={formik}
            label='bairro'
            labelTexto='Bairro'
            placeholder='Jardim Cuiabá'
            required
          />

          <InputComLabelFormik
            formik={formik}
            label='cep'
            mask='cep'
            maxLength={9}
            labelTexto='CEP'
            placeholder='12345-678'
            required
          />

          <InputComLabelFormik
            formik={formik}
            label='email'
            labelTexto='Email'
            placeholder='exemplo@email.com'
            required
            type='email'
          />

          <InputComLabelFormik
            formik={formik}
            label='telefone'
            mask='telefone'
            labelTexto='Telefone'
            placeholder='(12) 3456-7890'
            required
            maxLength={15}
          />

          <InputComLabelFormik
            formik={formik}
            label='telefone2'
            mask='telefone'
            labelTexto='Telefone 2'
            placeholder='(12) 3456-7890'
            maxLength={15}
          />

          <InputComLabelFormik
            formik={formik}
            label='nome_responsavel'
            labelTexto='Nome Completo do(a) Responsável pela Unidade Administrativa'
            placeholder='João da Silva'
            required
          />

          <InputComLabelFormik
            formik={formik}
            label='email_responsavel'
            labelTexto='Email do(a) Responsável pela Unidade Administrativa'
            placeholder='exemplo@email.com'
            type='email'
            required
          />
        </Box>
      </ContainerFormFormik>
      <ButtonForm
        disabled={formik.isSubmitting}
        onBack={handleVoltar}
        onAdvanced={handleAvancar}
        stepAtual={stepAtual}
        totalSteps={totalSteps}
      />
    </>
  );
};

export default Step1;
